import type { FunctionComponent } from "react";

import CardValue from "~/components/Card/components/CardValue.tsx";
import Headline from "~/components/Headline";
import type { EInvoicePreviewResponse } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { formatEInvoiceDate } from "../eInvoiceFormat.ts";

type Props = { billingPeriod: EInvoicePreviewResponse["billingPeriod"] };

const EInvoiceBillingPeriodSection: FunctionComponent<Props> = ({ billingPeriod }) => (
	<div className="flex flex-col gap-3">
		<Headline type="h5">Leistungszeitraum</Headline>
		<CardValue label="Von">{formatEInvoiceDate(billingPeriod.startDate)}</CardValue>
		<CardValue label="Bis">{formatEInvoiceDate(billingPeriod.endDate)}</CardValue>
	</div>
);

export default EInvoiceBillingPeriodSection;
